import { Box } from "@mui/material";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number | string;
    value: number | string;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
            style={{ height: "100%", width: "100%" }}
        >
            {value === index && (
                <Box sx={{ height: "100%", width: "100%" }}>{children}</Box>
            )}
        </div>
    );
}

export default TabPanel;
